module.exports = __webpack_public_path__ + "static/media/nsk.a4deb3bc.png";